module.exports = __webpack_public_path__ + "img/number-thumb-25.c0826b26.jpg";